import { useAuth } from '@pflegia/ui/contexts/auth.context';
import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';

export const useHideJobBoardLink = () => {
  const { isPraxia } = useFlavorFromRoute();
  const authenticated = useAuth();

  return isPraxia && !authenticated;
};
